// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.map.constructor');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/modules/es.map.js
// module id = 588
// module chunks = 0 1